import React from "react"
import "./TMHFooterStyles.scss"

export default function TMHFooter({isFixed=false}) {
  return (
    <nav className="wrapper-footer-v2" style={isFixed?{position:"fixed"}:{}}>
      <a href="https://themoviehouse.tv/tmh/#/privacy-policy" rel="noreferrer" target="_blank">
        Privacy policy
      </a>
      <a href="https://themoviehouse.tv/tmh/#/terms-conditions" rel="noreferrer" target="_blank">
        Terms &#38; conditions
      </a>
      <a href="https://themoviehouse.tv/tmh/#/about" rel="noreferrer" target="_blank">
        About
      </a>
    </nav>
  )
}